import { useQuery } from '@tanstack/react-query';
import { getWhatsAppContact } from '@/services/whatsapp.service';

export function useWhatsAppContact(clienteId: string | undefined) {
  return useQuery({
    queryKey: ['whatsapp-contact', clienteId],
    queryFn: () => getWhatsAppContact(clienteId!),
    enabled: !!clienteId,
    staleTime: 60_000,
  });
}
